module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAWCAYAAAAb+hYkAAAABHNCSVQICAgIfAhkiAAAAStJREFUOE+l1MtKw0AUBuD/z2K8gO4FX8SqCNLU2zuYtDt3PlG1fQAv+ApNBPG2diu40XpZOUWYIwmZEGMmNZjlZD5Ozi3EH56vuLthRAYAFiBywGnmM+puepALAPPJXQGea5G+7LVpzLkFWYAHJ9JR0CF4WgIfpOlUojqgWsOrX0jH3S2KJBHmCvm+UzxfrfWvk7MfSMfhNgUJmC2ANxrx1frgxp7lSI/2d0gvATN1II+ko2CP4AkAVQCv9OirlaPbcluoR+EumX5SEYxJ46vW8K6qj5xE4ROAJftSIC8e6KvV43tX4zmJgkeAy42QI58xgbYrWlo9J3TkNa3klRX8X3NtIbIxOitNhXuMSrA8f+mEVw5sDpuuRg6bLqGFjdfdwuzH0hfIIgWH3yyKoKRVHSdaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-next.png
// module id = 390
// module chunks = 1